import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forma-acesso',
  templateUrl: 'forma-acesso.component.html',
  styleUrls: ['./forma-acesso.component.scss']
})

export class FormasAcessoComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}